import { render, staticRenderFns } from "./loan.vue?vue&type=template&id=2b4156b8&scoped=true&"
import script from "./loan.vue?vue&type=script&lang=js&"
export * from "./loan.vue?vue&type=script&lang=js&"
import style0 from "./loan.vue?vue&type=style&index=0&id=2b4156b8&scoped=true&lang=css&"
import style1 from "./loan.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4156b8",
  null
  
)

export default component.exports